import { SideNavFeatures } from '@app/interfaces/sideNavigation';
import { useAppSelector } from './reduxHooks';
import {
  breedingJournalAclSelector,
  inspectionsAclSelector,
  observationsAclSelector,
  paperStatisticsAclSelector,
  professionalFishersAclSelector,
  huntersKillsAclSelector,
  reportsAclSelector,
  workflowsAclSelector,
  generalSettingsAclSelector,
  netTypesAclSelector,
  waterBodiesAclSelector,
  waterbodyRegulationsAclSelector,
  geographicAreasAclSelector,
  licenseTypesAclSelector,
  fishTypesAclSelector,
  membersAclSelector,
  rolesAclSelector,
  organisationalUnitsAclSelector,
  adminUsersAclSelector,
  analyticsFishingOperationsAclSelector,
  analyticsFishingManagementAclSelector,
  analyticsFishingHabitatAclSelector,
  analyticsProfessionalFishersAclSelector,
  analyticsHuntingOperationsAclSelector,
  huntingInspectionsAclSelector,
  killsAclSelector,
  huntersAclSelector,
  stockingPlanAclSelector,
  stockingJournalAclSelector,
  stockingYearlySummaryAclSelector,
  inventoryAclSelector,
  naturalBreedingAclSelector,
  fishMovementAclSelector,
  draughtinessAclSelector,
  waterQualityAclSelector,
  licensesAclSelector,
  licensesReturnAclSelector,
  fishersAclSelector,
  sessionsAclSelector,
  catchesAclSelector,
  analyticsSummaryAclSelector,
  analyticsBasicStatisticsAclSelector,
  dashboardHomeAclSelector,
} from '@app/store/slices/userSlice';

function useNavMenuFeatures(): SideNavFeatures {
  const features: SideNavFeatures = {};

  features['homeFeature'] = useAppSelector(dashboardHomeAclSelector);
  features['licensesFeature'] = useAppSelector(licensesAclSelector);
  features['licensesReturnFeature'] = useAppSelector(licensesReturnAclSelector);
  features['fishersFeature'] = useAppSelector(fishersAclSelector);
  features['sessionsFeature'] = useAppSelector(sessionsAclSelector);
  features['catchesFeature'] = useAppSelector(catchesAclSelector);
  features['inspectionsFeature'] = useAppSelector(inspectionsAclSelector);
  features['paperStatisticsFeature'] = useAppSelector(paperStatisticsAclSelector);

  features['inventoryFeature'] = useAppSelector(inventoryAclSelector);
  features['naturalBreedingFeature'] = useAppSelector(naturalBreedingAclSelector);
  features['stockingPlanFeature'] = useAppSelector(stockingPlanAclSelector);
  features['stockingJournalFeature'] = useAppSelector(stockingJournalAclSelector);
  features['stockingYearlySummaryFeature'] = useAppSelector(stockingYearlySummaryAclSelector);
  features['breedingJournalFeature'] = useAppSelector(breedingJournalAclSelector);

  features['fishMovementFeature'] = useAppSelector(fishMovementAclSelector);
  features['observationsFeature'] = useAppSelector(observationsAclSelector);
  features['draughtinessFeature'] = useAppSelector(draughtinessAclSelector);
  features['waterQualityFeature'] = useAppSelector(waterQualityAclSelector);

  features['professionalFishersFeature'] = useAppSelector(professionalFishersAclSelector);
  features['huntersKillsFeature'] = useAppSelector(huntersKillsAclSelector);

  features['huntersFeature'] = useAppSelector(huntersAclSelector);
  features['killsFeature'] = useAppSelector(killsAclSelector);
  features['huntingInspectionsFeature'] = useAppSelector(huntingInspectionsAclSelector);

  features['analyticsFishingOperationsFeature'] = useAppSelector(analyticsFishingOperationsAclSelector);
  features['analyticsFishingManagementFeature'] = useAppSelector(analyticsFishingManagementAclSelector);
  features['analyticsFishingHabitatFeature'] = useAppSelector(analyticsFishingHabitatAclSelector);
  features['analyticsProfessionalFishersFeature'] = useAppSelector(analyticsProfessionalFishersAclSelector);
  features['analyticsHuntingOperationsFeature'] = useAppSelector(analyticsHuntingOperationsAclSelector);
  features['analyticsSummaryFeature'] = useAppSelector(analyticsSummaryAclSelector);
  features['analyticsBasicStatisticsFeature'] = useAppSelector(analyticsBasicStatisticsAclSelector);

  features['membersFeature'] = useAppSelector(membersAclSelector);
  features['rolesFeature'] = useAppSelector(rolesAclSelector);
  features['organisationalUnitsFeature'] = useAppSelector(organisationalUnitsAclSelector);
  features['adminUsersFeature'] = useAppSelector(adminUsersAclSelector);

  features['waterbodiesFeature'] = useAppSelector(waterBodiesAclSelector);
  features['waterbodyRegulationsFeature'] = useAppSelector(waterbodyRegulationsAclSelector);
  features['geographicAreasFeature'] = useAppSelector(geographicAreasAclSelector);
  features['licenseTypesFeature'] = useAppSelector(licenseTypesAclSelector);
  features['fishTypesFeature'] = useAppSelector(fishTypesAclSelector);
  features['netTypesFeature'] = useAppSelector(netTypesAclSelector);

  features['reportsFeature'] = useAppSelector(reportsAclSelector);

  features['generalSettingsFeature'] = useAppSelector(generalSettingsAclSelector);
  features['workflowsSettingsFeature'] = useAppSelector(workflowsAclSelector);

  return features;
}

export default useNavMenuFeatures;
